import ProjectCreate from '../ProjectCreate';
import RecapEdit from './RecapEdit';

export default {
	edit: RecapEdit,
	create: ProjectCreate
};
